import { AssetResultsChart } from "./AssetResultsChart";

type AssetResultsCellProps = {
  blastRadius?: AssetResultsChart["blastRadius"] | null;
  inPreviewMode?: AssetResultsChart["inPreviewMode"];
};

export const AssetResultsCell = ({
  blastRadius,
  inPreviewMode,
}: AssetResultsCellProps) => {
  if (!blastRadius) {
    return;
  }

  return (
    <AssetResultsChart
      blastRadius={blastRadius}
      inPreviewMode={inPreviewMode}
    />
  );
};
